import { Route, createPageRoute, AppId } from '@lumapps/router';

export const tasksRoute: Route = createPageRoute({
    slug: 'tasks',
    appId: AppId.frontOffice,
});

export const newTaskRoute: Route = createPageRoute({
    slug: 'tasks/~new',
    appId: AppId.frontOffice,
});

export const editTaskRoute: Route = createPageRoute({
    slug: 'tasks/:id/~edit',
    appId: AppId.frontOffice,
});

export const viewTaskRoute: Route = createPageRoute({
    slug: 'tasks/:id',
    appId: AppId.frontOffice,
});
